<template>
  <BaseTemplate :currentUser="currentUser">
    <Title class="_title" :jpn="t('マーケット購入品')" />
    <div class="buy-product-history-detail">
      <div class="flex-box">
        <MarketCardList
          v-if="cardList"
          :cardList="cardList.items"
          :cardListTitle="t('検索結果')"
          :currentUser="userDetail"
          :historyView="true"
          />
      </div>
      <div class="cart-summary">
        <div class="summary-row">
          <span class="price-title">{{t('小計')}}</span>
          <span>{{ subtotal | comma }}{{t('円')}}</span>
        </div>
        <div class="summary-row">
          <span class="price-title">{{t('送料')}}</span>
          <span>{{ cardList.purchase.shipping_fee | comma }}{{t('円')}}</span>
        </div>
        <div class="summary-row total">
          <span class="price-title">{{t('合計')}}</span>
          <span>{{ cardList.purchase.total_amount | comma }}{{t('円')}}</span>
        </div>
      </div>
      <BlackGradationButton
            class="square-button"
            :text="t('一覧に戻る')"
            @handleSquareBtnClick="goToMarketHistory"
          />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
// import GrayBack from '@/components/molecules/GrayBack.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import MarketCardList from '@/components/organisms/MarketCardList.vue';

export default {
  name: 'BuyProductHistoryDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    // GrayBack,
    BlackGradationButton,
    Title,
    MarketCardList,
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      buyMarketHistory: 'market/resultMarketPurchaseDetail',
    }),
    cardList() {
      if (this.buyMarketHistory) {
        return this.buyMarketHistory;
      }
      return null;
    },
    subtotal() {
      if (this.cardList) {
        return this.cardList.purchase.total_amount - this.cardList.purchase.shipping_fee;
      }
      return 0;
    },
  },
  created() {
    this.$store.dispatch('market/purchase_detail', { id: this.$route.query.id });
  },

  methods: {
    goToMarketHistory() {
      this.$router.push('/market-history');
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  margin-top: 20px;
}
.square-button{
  margin: 0 auto;
  width: 200px;
  height: 40px;
}
.cart-summary {
  margin-top: 16px;
  font-weight: bold;
  font-size: 15px;
  border-top: 2px solid $gray;
  border-radius: 3px;
  padding: 5px;
  margin: 20px auto 0 auto;
  max-width: 700px;
  @media screen and (min-width: 1338px) {
    max-width: 1306px;
  }
  @media screen and (min-width: 1672px) {
    max-width: 1636px;
  }
  @media screen and (min-width: $tabletWidth) {
    max-width: 90%;
  }
  .summary-row {
    display: flex;
    justify-content: flex-end;
    padding: 4px 0;
    color: black;
    .price-title {
      color: $gray2;
      margin-right: 8px;
    }
    &.total {
      // border-top: 2px solid #000;
      margin-top: 6px;
      padding-top: 6px;
      font-size: 18px;
    }
  }
}
</style>
